import { appConfig } from "src/config";
import { getAuthorizationHeader } from "src/api/utils";
import type { ProductCatalogGetResponseProto } from "@noom/noom-contracts/noom_contracts/billing/product_catalog/product_catalog_service";

/**
 * Fetches a product catalog entry by sale item ID.
 * Returns subscription, trial, add-on, or bundle sale item details depending
 * on the type of the provided sale item.
 */
export async function getProduct(
  saleItemId: string
): Promise<ProductCatalogGetResponseProto> {
  const response = await fetch(
    `${appConfig.BILLING_CORE_API_URL}/billing/v2/products/${saleItemId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthorizationHeader(),
      },
    }
  );
  if (!response.ok) {
    throw new Error(`Failed to get product: ${response.status}`);
  }
  return response.json();
}
